<template>
  <!-- 搜索 -->
  <div ref="topDom" class="header-bar">
    <div class="bar-lef">
      <div class="lef-one">
        <a-button class="btn-primary" @click="handleAdd">创建房型</a-button>
      </div>
    </div>
    <div class="bar-rig">
      <div class="rig-one">
        <a-input-search v-model:value="searchForm.name" :loading="searchLoading" placeholder="请输入房型名称" @search="getTableList"> </a-input-search>
      </div>
    </div>
  </div>

  <!-- 表格 -->
  <a-table :columns="columns" :dataSource="dataSource" :loading="searchLoading" :pagination="false" :scroll="{ y: tableHeight }" class="table" size="small">
    <template #bodyCell="{ column, record }">
      <template v-if="column.key == 'name'">
        <div style="display: flex">
          <img
            :src="imgCut(record.image ? record.image : companyLogo, 'xl')"
            alt="房源图片"
            fit="fill"
            style="width: 80px; height: 50px; object-fit: cover; cursor: pointer"
            @click="goRouter('/pms/landlord/room/details', record)"
          />
          <div class="editable-cell house-info">
            <div v-if="editId.includes(record.id)" class="editable-cell-input-wrapper">
              <a-input v-model:value="record.name" size="small"></a-input>
              <check-outlined class="editable-cell-icon-check" @click="editSave(record)" />
            </div>
            <div v-else class="editable-cell-text-wrapper">
              {{ record.name }}
              <edit-outlined class="f-c-999 editable-cell-icon" style="margin-left: 10px; cursor: pointer" @click="editId.push(record.id)" />
            </div>
          </div>
        </div>
      </template>
      <template v-if="column.key == 'channel'">
        <div class="logo">
          <a-avatar v-for="(item, index) of record.ota_list" :key="index" :size="20" :src="item.logo" :title="item.ota_name" class="avatar" />
          <plus-circle-outlined class="f-20" style="color: #1890ff; cursor: pointer" @click="goRouter('/pms/landlord/room/details', record, 4)" />
        </div>
      </template>
      <template v-if="column.key == 'operate'">
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多
            <DownOutlined />
          </a>
          <template #overlay>
            <a-menu>
              <a-menu-item @click="handleDel(record)">
                <div class="f-c-red">移除此房型</div>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </template>
    </template>
  </a-table>

  <!-- 分页 -->
  <MyPagination :pageTotal="pageTotal" @onShowSizeChange="onShowSizeChange" @pageChange="pageChange" />

  <!-- 添加房型弹窗 -->
  <a-modal v-model:visible="visibleAdd" :width="600" title="创建房型" @ok="addSave">
    <a-form ref="formRef" :label-col="{ span: 4 }" :model="addForm" :rules="rules" labelAlign="left">
      <div class="modal-ctitle">基本信息</div>
      <a-form-item label="房型名称：" name="name">
        <a-input v-model:value="addForm.name" placeholder="请输入房型名称" style="width: 100%" />
      </a-form-item>
      <a-form-item label="房型图片：" name="image">
        <a-upload
          :action="action"
          :before-upload="beforeUpload"
          :data="formData"
          :headers="header"
          :show-upload-list="false"
          class="avatar-uploader"
          list-type="picture-card"
          name="image"
          @change="handleChange"
        >
          <img v-if="addForm.image" :src="addForm.image" alt="avatar" fit="fill" style="width: 133px; height: 100px" />
          <div v-else>
            <loading-outlined v-if="uploadLoading"></loading-outlined>
            <plus-outlined v-else></plus-outlined>
            <div class="ant-upload-text">选择图片</div>
          </div>
        </a-upload>
      </a-form-item>
      <div class="modal-ctitle">价格策略</div>
      <a-form-item label="周日-周四：" name="sun_to_thur">
        <a-input v-model:value="addForm.sun_to_thur" placeholder="请输入价格" prefix="￥" style="width: 100%" />
      </a-form-item>
      <a-form-item label="周五-周六：" name="fri_to_sat">
        <a-input v-model:value="addForm.fri_to_sat" placeholder="请输入价格" prefix="￥" style="width: 100%" />
      </a-form-item>
      <a-form-item label="节假日：" name="holiday">
        <a-input v-model:value="addForm.holiday" placeholder="请输入价格" prefix="￥" style="width: 100%" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { createVNode, onMounted, reactive, toRefs, watch } from 'vue';
import { roomAdd, roomDel, roomEdit, roomList } from '@/api/api';
import { CheckOutlined, DownOutlined, EditOutlined, ExclamationCircleOutlined, LoadingOutlined, PlusCircleOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { message, Modal } from 'ant-design-vue';
import useUtils from '@/hooks/useUtils.js'; //工具库
import { verifyPrice } from '@/common/validator';
import store from '@/store/pms/landlord/index'; //VUEX
import router from '@/router/index';
import { baseRequestUrl } from '../../../../config.js';

export default {
  components: {
    PlusCircleOutlined,
    DownOutlined,
    PlusOutlined,
    EditOutlined,
    LoadingOutlined,
    CheckOutlined,
  },
  setup() {
    let { imgCut, countModal, countTable } = useUtils();

    // 搜索
    let search = reactive({
      topDom: '',
      searchForm: {
        name: '',

        start: 0,
        limit: store.getters.getPageSize,
      },
      searchLoading: false,
      handleOpen(params) {
        search.positionModal = countModal(params);
        modal.visibleRoom = true;
      },
    });

    // 表格
    let table = reactive({
      editId: [],
      editSave(item) {
        roomEdit({
          rid: item.id,
          name: item.name,
        }).then(res => {
          message.success(res.msg);
          table.editId.splice(table.editId.indexOf(item.id), 1);
        });
      },
      tableHeight: '',
      dataSource: [],
      columns: [
        {
          title: '名称',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: '关联的渠道',
          dataIndex: 'channel',
          key: 'channel',
        },
        {
          title: '',
          dataIndex: 'operate',
          key: 'operate',
        },
      ],
      companyLogo: JSON.parse(sessionStorage.getItem('companyInfo') || '{}').logo || '',
      getTableList() {
        search.searchLoading = true;
        roomList({
          name: search.searchForm.name,
          start: search.searchForm.start,
          limit: search.searchForm.limit,
        })
          .then(res => {
            table.dataSource = res.data.list;
            pagination.pageTotal = res.data.count;
            search.searchLoading = false;
          })
          .catch(() => {
            search.searchLoading = false;
          });
      },
      goRouter(url, params = {}, tab = 1) {
        router.push({ path: url, query: { rid: params.id, tab: tab } });
      },
    });

    // 弹窗
    let modal = reactive({
      visibleRoom: false,
      visibleAdd: false,
      CompanyOta: [],
      loading: false,
      handleAdd() {
        modal.visibleAdd = true;
      },
      addForm: {
        name: '',
        image: '',
        sun_to_thur: '',
        fri_to_sat: '',
        holiday: '',
      },
      formRef: '', //表单验证
      rules: {
        name: [
          {
            required: true,
            message: '请输入房型名称',
            trigger: 'blur',
          },
        ],
        image: [
          {
            required: false,
            message: '请上传房型图片',
            trigger: 'blur',
          },
        ],
        sun_to_thur: [
          {
            required: false,
            validator: verifyPrice,
            trigger: 'blur',
          },
        ],
        fri_to_sat: [
          {
            required: false,
            validator: verifyPrice,
            trigger: 'blur',
          },
        ],
        holiday: [
          {
            required: false,
            validator: verifyPrice,
            trigger: 'blur',
          },
        ],
      },

      // 上传
      uploadLoading: false,
      action: baseRequestUrl + '/h5/upload/uploadImg' + '?info=' + JSON.parse(sessionStorage.getItem('landlordInfo')).info,
      header: {
        token: JSON.parse(sessionStorage.getItem('landlordInfo')).token,
        version: '1.0.0',
        source: '1',
      },
      formData: {
        module: 'pms',
        type: 'logo',
      },
      handleChange(info) {
        if (info.file.status === 'uploading') {
          modal.uploadLoading = true;
          return;
        }
        if (info.file.status === 'done') {
          modal.addForm.image = info.file.response.data.url;
          modal.uploadLoading = false;
          modal.formRef.validate('image');
        }
        if (info.file.status === 'error') {
          modal.uploadLoading = false;
          message.error('上传错误');
        }
      },
      beforeUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
          message.error('只能上传jpg、png格式图片!');
        }
        return isJpgOrPng;
      },

      // 新增保存
      addSave() {
        modal.formRef.validate().then(() => {
          modal.addForm.price_room = JSON.stringify({
            sun_to_thur: modal.addForm.sun_to_thur,
            fri_to_sat: modal.addForm.fri_to_sat,
            holiday: modal.addForm.holiday,
          });
          roomAdd(modal.addForm).then(res => {
            message.success(res.msg);
            modal.visibleAdd = false;
            table.getTableList();
            if (modal.formRef) {
              modal.formRef.resetFields();
            }
          });
        });
      },

      // 删除房型
      handleDel(item) {
        Modal.confirm({
          title: '确定移除此房型？',
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            roomDel({ rid: item.id }).then(res => {
              message.success(res.msg);
              table.getTableList();
            });
          },
        });
      },
    });

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableList();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableList();
      },
    });

    watch(
      () => store.state.ContentHeight,
      () => {
        table.tableHeight = countTable(search.topDom);
      }
    );

    onMounted(() => {
      table.getTableList();
      table.tableHeight = countTable(search.topDom);
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(modal),
      ...toRefs(pagination),
      imgCut,
    };
  },
};
</script>

<style lang="scss" scoped>
.logo {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  .avatar {
    margin-right: 2px;
  }
}

.house-info {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-left: 10px;
}

.modal-header {
  padding: 5px 10px;
  background-color: #f4f4f4;
}

.modal-content {
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 50px;

  .opt-one {
    padding: 1px 8px;
    border: 1px solid #f4f4f4;
    margin-right: 10px;
  }
}

.modal-ctitle {
  margin-bottom: 20px;
  padding: 5px;
  font-weight: bold;
  border-bottom: 1px solid #f2f2f2;
}

:deep(.avatar-uploader > .ant-upload) {
  width: 133px !important;
  height: 100px !important;
}

:deep(.ant-upload-select-picture-card i) {
  font-size: 32px;
  color: #999;
}

:deep(.ant-upload) {
  width: 133px !important;
  height: 100px !important;
  padding: 0 !important;
}

:deep(.ant-upload-select-picture-card .ant-upload-text) {
  margin-top: 8px;
  color: #666;
}

.editable-cell {
  position: relative;

  .editable-cell-input-wrapper,
  .editable-cell-text-wrapper {
    // padding-right: 24px;
    display: flex;
    align-items: center;
  }

  .editable-cell-text-wrapper {
    // padding: 5px 24px 5px 5px;
  }

  .editable-cell-icon,
  .editable-cell-icon-check {
    // position: absolute;
    // right: 0;
    // width: 20px;
    cursor: pointer;
  }

  .editable-cell-icon {
    margin-top: 4px;
    display: none;
  }

  .editable-cell-icon-check {
    line-height: 28px;
  }

  .editable-cell-icon:hover,
  .editable-cell-icon-check:hover {
    color: #108ee9;
  }

  .editable-add-btn {
    margin-bottom: 8px;
  }
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}
</style>
